import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActions } from "@mui/material";
import { Btn } from "../../Samvenda-Patient/UI/Button";
import { utils, writeFile } from "xlsx";
import {
  getReportAssessment,
  getReports,
} from "../../services/admin/AssessmentReport";
import { useState } from "react";
import { CircularProgress } from "../../../node_modules/@mui/material/index";
import toast from "../../../node_modules/react-hot-toast/dist/index";
import styles from "./DownloadReportCard.module.css";

export default function DownloadReportCardAll({ assessmentData, date }) {
  const [disable, setDisable] = useState(false);
  const handledownload = (callback) => {
    setDisable(true);
    getReportAssessment(date)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        setDisable(false);
      });
  };

  const convertExcel = (assessmentResult) => {
    toast.remove();
    const wb = utils.book_new();
    const ws = utils.json_to_sheet(assessmentResult);
    utils.book_append_sheet(wb, ws, "Report");
    writeFile(wb, `${assessmentData.name}.xlsx`);
    setDisable(false);
  };

  return (
    <>
      <div className={styles.reportCard}>
        <Card
          sx={{
            maxWidth: 300,
            minWidth: 300,
            minHeight: 180,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            boxShadow: "none",
          }}
        >
          <CardContent sx={{ minHeight: 100 }}>
            <Typography
              gutterBottom
              style={{ fontSize: "1.4rem" }}
              variant="h5"
              component="div"
            >
              {assessmentData.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click Below to download the {assessmentData.name} Report
            </Typography>
          </CardContent>
          <CardActions>
            <Btn
              bgColor="#00B091"
              variant="outlined"
              color="white"
              disabled={disable}
              click={() => {
                handledownload(convertExcel);
              }}
              width="150px"
            >
              {disable ? (
                <CircularProgress
                  sx={{
                    height: "25px!important",
                    width: "25px!important",
                    color: "white",
                  }}
                />
              ) : (
                "Download Report"
              )}
            </Btn>
          </CardActions>
        </Card>
      </div>
    </>
  );
}
